'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('cacmModule')
    .factory('cacmService', ['$http', '$q', function($http, $q) {
        var baseUrl = environment.apiUrl + '/Pilot/api/CACM';

        return {

            // Get data to display EventStatus summary
            getCACMEventsSummary: function () {
                return $http
                    .get(baseUrl + '/Event/Summary')
                    .then(function (response) { return response.data; });
            },

            // Get one CACM event info
            getCacmEvent: function(eventId) {
                return $http
                    .get(baseUrl + '/Event/' + eventId)
                    .then(function (response) { return response.data; });
            },

            // Group CACM Events
            groupEvents: function(message, eventIds) {
                return $http
                    .post(baseUrl + '/Event/Group/New', {description: message, cacmEventIDs: eventIds.join(',')})
                    .then(function (response) { return response.data; });
            },

            // Add CACM Event(s) to group
            addEventsToGroup: function(groupId, eventIds) {
                return $http
                    .post(baseUrl + '/Event/Group/' + groupId + '/Add', {cacmEventIDs: eventIds.join(',')})
                    .then(function (response) { return response.data; });
            },

            // Add CACM Event(s) to group
            getCompatibleGroups: function(eventId) {
                return $http
                    .get(baseUrl + '/Event/Group/Compatible/ByEvent/' + eventId)
                    .then(function (response) { return response.data; });
            },

            // Ungroup a complete group
            ungroupAllFromGroup: function(eventId) {
                return $http
                    .delete(baseUrl + '/Event/Group/' + eventId)
                    .then(function (response) { return response.data; });
            },

            // Ungroup one child event from a group
            removeEventFromGroup: function(eventId, groupEventId) {
                return $http
                    .post(baseUrl + '/Event/Group/' + groupEventId + '/Remove', {cacmEventIDs: eventId})
                    .then(function (response) { return response.data; });
            },

            // Get one CACM event info
            getDataPointForEvent: function(eventId) {
                return $http
                    .get(baseUrl + '/Event/' + eventId + '/DataPoint')
                    .then(function (response) { return response.data; });
            },

            // Get follow-ups for a CACM event
            getFollowUpsForEvent: function(eventId) {
                return $http
                    .get(baseUrl + '/Event/' + eventId + '/FollowUp')
                    .then(function (response) { return response.data; });
            },

            getDownloadAttachmentUrl: function (eventId, attachmentId) {
                return baseUrl + '/Event/' + eventId + '/FollowUp/Attachment/' + attachmentId;
            },

            // Lookups
            getAllLookups: function () {
                return $http
                        .get(baseUrl + '/Lookup', { cache: true })
                        .then(function (response) { return response.data; });
            },

            saveFollowUpDraft: function(eventID, draft) {
                return this.followUpPostAction('CreateOrUpdate', eventID, draft);
            },

            postFollowUp: function(eventID, followUp) {
                return this.followUpPostAction('Post', eventID, followUp);
            },

            investigateFollowUp: function(eventID, followUp) {
                return this.followUpPostAction('Investigate', eventID, followUp);
            },

            closeFollowUp: function(eventID, followUp) {
                return this.followUpPostAction('Close', eventID, followUp);
            },

            deleteFollowUp: function(eventID, followUp) {
                return $http
                    .delete(baseUrl + '/Event/' + eventID + '/FollowUp/' + followUp.FollowUpID)
                    .then(function (response) { return response.data; });
            },

            followUpPostAction: function(action, eventID, followUp) {
                return $http
                    .post(baseUrl + '/Event/' + eventID + '/FollowUp/' + action, followUp)
                    .then(function (response) { return response.data; });
            }
        }
    }]);
